const Faqs = () => {
  const init = () => {
    let timeout = false;

    // Custom contains function (case-insensitive)
    const containsInsensitive = (text, search) => text.toUpperCase().includes(search.toUpperCase());

    const clearSearch = () => {
      const searchInput = document.querySelector('[data-filter-search-text]');
      if (searchInput) searchInput.value = '';
      clearResults();
    };

    const clearResults = () => {
      document.querySelectorAll('[data-filtering]').forEach(el => {
        el.classList.remove('d-none');
        el.querySelector('.answer')?.classList.remove('show');
      });
      document.querySelector('article.noResult')?.classList.add('d-none');
      const resultsCount = document.querySelector('.results-count');
      if (resultsCount) resultsCount.style.opacity = '0';
    };

    document.querySelector('.clear-search')?.addEventListener('click', clearSearch);

    document.querySelector('[data-filter-search-text]')?.addEventListener('keyup', e => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const search = e.target.value;
        document.querySelectorAll('[data-filtering]').forEach(el => el.classList.remove('d-none'));

        if (search.length > 0) {
          document.querySelectorAll('[data-filtering]').forEach(el => {
            if (!containsInsensitive(el.textContent, search)) {
              el.classList.add('d-none');
            } else {
              el.querySelector('.answer')?.classList.add('show');
            }
          });

          const visibleCount = document.querySelectorAll('[data-filtering]:not(.d-none)').length;
          const resultsCount = document.querySelector('.results-count');
          if (resultsCount) {
            resultsCount.style.opacity = '1';
            const countEl = resultsCount.querySelector('.count');
            if (countEl) countEl.textContent = `Showing ${visibleCount} results for "${search}"`;
          }
        } else {
          clearResults();
        }
      }, 200);
    });
  };

  if (document.querySelector('[data-faq-filter]')) {
    init();
  }
};

export default Faqs;